'use client';
import { useTranslations } from 'next-intl';
import AudioPlayerClient from './client-component';
import type { IAudioPlayerProps } from '@metmuseum/types';

const AudioPlayer = (props: IAudioPlayerProps) => {
	const t = useTranslations('audio');
	return <AudioPlayerClient {...props} t={t} />;
};

export default AudioPlayer;
